/**
 * DADDL — Custom initialisation script
 * Keeps all DOM-manipulation in one safe asset file
 * so theme.liquid only needs a single <script> reference.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    /* ---- Hero heading: split into two-tier layout ---- */
    var heading = document.querySelector('.vso-hero-33__heading');
    if (heading) {
      var text = heading.textContent.trim();
      var splitAt = text.lastIndexOf('. ');

      if (splitAt !== -1) {
        var line1 = text.substring(0, splitAt + 1);
        var line2 = text.substring(splitAt + 2);

        heading.innerHTML =
          '<span class="daddl-heading__line1">' + line1 + '</span>' +
          '<span class="daddl-heading__line2">' + line2 + '</span>';
      }

      var line2El = heading.querySelector('.daddl-heading__line2');
      if (line2El && customElements.get('sparkly-text')) {
        var sparkle = document.createElement('sparkly-text');
        sparkle.setAttribute('number-of-sparkles', '3');
        sparkle.textContent = line2El.textContent;
        line2El.textContent = '';
        line2El.appendChild(sparkle);
      }
    }

    /* ---- "Dare to Daddl" section: style heading + subtitle ---- */
    var allH2 = document.querySelectorAll('div[class^="featured-heading-"] h2');
    allH2.forEach(function (h2) {
      if (h2.textContent.trim() !== 'Dare to Daddl') return;

      var wrapper = h2.closest('div[class^="featured-heading-"]');
      if (!wrapper) return;
      wrapper.classList.add('daddl-section-heading');

      h2.innerHTML =
        '<span class="daddl-dare__prefix">Dare to</span> ' +
        '<span class="daddl-dare__name">Daddl</span>';

      var sibling = wrapper.nextElementSibling;
      if (sibling && sibling.className.indexOf('featured-text-') !== -1) {
        sibling.classList.add('daddl-section-subtitle');

        var p = sibling.querySelector('p');
        if (p) {
          var parts = p.textContent.split('. ');
          if (parts.length >= 3) {
            p.innerHTML = parts.map(function (part, i) {
              return '<span class="daddl-subtitle__segment">' +
                part + (i < parts.length - 1 ? '.' : '') +
                '</span>';
            }).join(' ');
          }
        }
      }
    });

    /* ---- Footer: clone payment icons between copyright & policies on mobile ---- */
    var payments = document.querySelector('.vso-footer-06__payments');
    var policies = document.querySelector('.vso-footer-06__policies');
    if (payments && policies && policies.parentNode) {
      var clone = payments.cloneNode(true);
      clone.classList.add('vso-footer-06__payments--mobile');
      policies.parentNode.insertBefore(clone, policies);
    }

  });
})();
